import {
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_FAIL,
  NOTIFICATION_GET_REQUEST,
  NOTIFICATION_GET_FAIL,
  NOTIFICATION_GET_SUCCESS,
  NOTIFICATION_READ_REQUEST,
  NOTIFICATION_READ_FAIL,
  NOTIFICATION_READ_SUCCESS,
} from "../constants/notificationConstants";
import api from "../core/api";

export const listNotifications = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(
      `/accounts/notifications/0`,
      config
    );

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: NOTIFICATION_LIST_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: NOTIFICATION_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getNotifications = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_GET_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(
      `/accounts/notifications/notification/${id}`,
      config
    );

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: NOTIFICATION_GET_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: NOTIFICATION_GET_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const markReadNotifications = (ntid) => async (dispatch, getState) => {
  try {
    dispatch({
      type: NOTIFICATION_READ_REQUEST,
    });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const { data } = await api.put(
      `/accounts/notifications/readNotification/${ntid}`,
      config
    );

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: NOTIFICATION_READ_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: NOTIFICATION_READ_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_READ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

